<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Elomark User</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editCompany"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.first_name"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              First Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.first_name }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.surname"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Surname:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.surname }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.email"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Email:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.email }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.desk_phone"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Desk Phone:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.desk_phone }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.mobile_no"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Mobile No.:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.mobile_no }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.softphone"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              SoftPhone:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.softphone }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.alternate_phone_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Alternate Phone 1:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.alternate_phone_1 }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.alternate_phone_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Alternate Phone 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.alternate_phone_2 }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.manager"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Manager:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.elo_manager }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.address_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Address 1:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.address_1 }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.address_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Address 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.address_2 }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.address_3"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Address 3:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.address_3 }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.city"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              City:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.city }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.county"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.county }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.postcode"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Postcode:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.postcode }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.country"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Country:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ countryName }}
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" class="mb-6" v-if="userDescription.dob">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Date Of Birth:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.dob }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.rate"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Rate:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.rate }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.contract_commencement_date"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Contract Commencement Date:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.contract_commencement_date }}
          </div>
        </vs-col>
        <template>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>
                Language:
              </span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <template v-for="language in userDescription.languages">
                <div class="pb-5">
                  {{ language.languages_name }} -
                  {{ language.language_competency_name }}
                </div>
              </template>
            </div>
          </vs-col>
        </template>

        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.timezone"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Timezone:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ timeZoneName }}
          </div>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.job_role"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Job Role:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.job_role }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.role_name"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Role:
            </span>
          </div>
          <div>
            {{ userDescription.role_name }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.user_status"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ elomarkStatus }}
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.user_type"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Type:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userTypeName }}
          </div>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-w="6"
          class="mb-6"
          v-if="userDescription.company_id"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Company:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ companyName }}
          </div>
        </vs-col>
      </div>
    </div>
  </vx-card>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleElomarkUsersManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import vSelect from "vue-select";
import moment from "moment";
export default {
  data() {
    return {
      abilities: null,
      userTypeName: null,
      countryName: null,
      companyName: null,
      userDescription: [],
      elomarkUserId: null,
      elomarkStatus: null,
      timeZoneName: null,
      langaugeCompetencyName: null,
      langaugeName: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleElomarkUsersManagement,
    moduleUserTypeManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleElomarkUsersManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUsersManagement
      );
      moduleElomarkUsersManagement.isRegistered = true;
    }
    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.elomarkUserId = this.$route.params.userId;
    this.fetchElomarkUser();
  },
  methods: {
    showCompanyName(accountId) {
      this.$store
        .dispatch("accountsManagement/fetchAccount", accountId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.companyName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    async showLanguageName(languageId) {
      let result = this.$store
        .dispatch("accountsManagement/fetchLanguage", languageId)
        .then(res => {
          if (res) {
            return res;
          }
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
      return result;
    },
    async showLanguageCompetencyName(languageId) {
      let result = await this.$store
        .dispatch("accountsManagement/fetchLanguageCompetency", languageId)
        .then(res => {
          if (res) {
            return res;
          }
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });

      return result;
    },
    // fetchUserLanguages() {
    //   this.$store
    //     .dispatch("elomarkUsersManagement/fetchUserLanguages", this.elomarkUserId)
    //     .then(res => {
    //       if (res) {
    //         this.userDescription.languages = res.data;

    //       }
    //     })
    //     .catch(err => {
    //       if (err.response.status === 404) {
    //         this.userDescription = true;
    //         return;
    //       }
    //       console.error(err);
    //     });
    // },
    fetchElomarkUser() {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", this.elomarkUserId)
        .then(res => {
          if (res) {
            this.userDescription = res.data;

            if (this.userDescription.user_status) {
              this.showElomarkStatus(this.userDescription.user_status);
            }

            if (this.userDescription.country) {
              this.showCountryName(this.userDescription.country);
            }

            if (this.userDescription.user_type) {
              this.showUserTypeName(this.userDescription.user_type);
            }

            if (this.userDescription.company_id) {
              this.showCompanyName(this.userDescription.company_id);
            }

            if (this.userDescription.timezone) {
              this.showTimeZoneName(this.userDescription.timezone);
            }

            this.userDescription.dob = moment(this.userDescription.dob).format(
              "DD/MM/YYYY"
            );
            this.userDescription.contract_commencement_date = moment(
              this.userDescription.contract_commencement_date
            ).format("DD/MM/YYYY");

            // this.fetchUserLanguages()
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    showCountryName(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.countryName = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showTimeZoneName(timezoneId) {
      this.$store
        .dispatch("elomarkUsersManagement/getTimeZone", timezoneId)
        .then(res => {
          this.timeZoneName = res.data.label;
          // console.log(this.timeZoneName);
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.timeZoneName = true;
            return;
          }
          console.error(err);
        });
    },
    showUserTypeName(usertypeId) {
      this.$store
        .dispatch("usertypesManagement/fetchUserType", usertypeId)
        .then(res => {
          if (res) {
            this.userTypeName = res.data.usertype;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.countryName = true;
            return;
          }
          console.error(err);
        });
    },
    showElomarkStatus(statusId) {
      this.$store
        .dispatch("elomarkUsersManagement/fetchStatus", statusId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.elomarkStatus = response.user_status;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    editCompany() {
      this.$router.push({ path: `edit/${this.elomarkUserId}` });
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
